<template>
    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400">
        <defs></defs>
        <path
            class="cls-1"
            d="M382,82.14V193.52c0,41.37.09,82.74,0,124.11-.07,32.14-21.88,60.37-53.67,67-12.94,2.71-27.43,1.34-40.56,1.34h-206c-8.94,0-17.62-.88-26.14-3.86a67.63,67.63,0,0,1-39.15-36.63C9.88,330.35,11,314.14,11,298.06V88.92a120.4,120.4,0,0,1,.54-15.67,67.45,67.45,0,0,1,27.93-46A68.65,68.65,0,0,1,78.93,15H303.8c3.65,0,7.31,0,11,0A67.14,67.14,0,0,1,382,82.14c.07,7.72,12.07,7.74,12,0C393.61,41,361.61,6.32,320.44,3.21,307.81,2.26,294.9,3,282.26,3H122.08c-14.46,0-28.93-.08-43.39,0C43.13,3.2,11,26.89,1.71,61.54-2.28,76.39-1,92.66-1,107.92V316.48c0,30.91,16.24,60,44.63,73.6C61,398.36,78.65,398,97.18,398H309.46c7.42,0,14.75-.24,22.06-1.77,19.31-4,36.37-15.66,47.86-31.57A79.63,79.63,0,0,0,394,318.59c0-4.31,0-8.61,0-12.92V82.14C394,74.42,382,74.41,382,82.14Z"
        />
        <path
            class="cls-1"
            d="M203.5,227.73a43,43,0,0,1-10-.18c1,0,2-.05,3-.05C198.85,227.5,201.19,227.58,203.5,227.73Z"
        />
        <path
            class="cls-1"
            d="M203.51,233.83c-1.33.11-2.66.17-4,.17a45.58,45.58,0,0,1-6.09-.4A97.23,97.23,0,0,1,203.51,233.83Z"
        />
        <path
            class="cls-1"
            d="M301.09,305.73a5.47,5.47,0,0,1-4.24,1.77H96.15c-3.78,0-7-3.85-5.79-7.6a110.43,110.43,0,0,1,72.78-73.11c2.05,1.52,4.16,2.94,6.32,4.23a68.3,68.3,0,0,0,8.34,4.27c12.19,5.18,25.74,6.48,39.52,1.72.69-.24,1.37-.49,2.05-.75a67.77,67.77,0,0,0,8.55-4,68.49,68.49,0,0,0,6.56-4.1,112.65,112.65,0,0,1,68.16,71.72A5.21,5.21,0,0,1,301.09,305.73Z"
        />
        <path
            class="cls-1"
            d="M203.5,227.73a43,43,0,0,1-10-.18c1,0,2-.05,3-.05C198.85,227.5,201.19,227.58,203.5,227.73Z"
        />
        <path
            class="cls-1"
            d="M203.51,233.83c-1.33.11-2.66.17-4,.17a45.58,45.58,0,0,1-6.09-.4A97.23,97.23,0,0,1,203.51,233.83Z"
        />
        <path
            class="cls-1"
            d="M203.5,227.73a43,43,0,0,1-10-.18c1,0,2-.05,3-.05C198.85,227.5,201.19,227.58,203.5,227.73Z"
        />
        <path
            class="cls-1"
            d="M260.51,154c-.24,26-14.7,53.84-37.4,67.19a49.39,49.39,0,0,1-4.73,2.46,46.56,46.56,0,0,1-14.88,4.07c-2.31-.15-4.65-.23-7-.23-1,0-2,0-3,.05a42.57,42.57,0,0,1-5.6-1.17,49.64,49.64,0,0,1-8.73-3.39c-8.77-4.37-16.31-11.17-22.38-18.81-16.24-20.47-24.13-50.05-13.19-74.73a61.79,61.79,0,0,1,63.53-36C237.51,97.15,260.2,123.72,260.51,154Z"
        />
    </svg>
</template>
